import {AppProps} from "../App";
import BillEntry, {BillEntryProps} from "../components/billEntry/BillEntry";
import {PdfDataService} from "../services/PdfData.service";
import BillResult from "../components/billResult/BillResult";
import Footer from "../components/footer/Footer";
import React from "react";
import BoothPreview from "../components/boothPreview/BoothPreview";
import logo from "./../assets/logo_orange.png";

const CompleteView = (props: AppProps) => {
    function renderBillEntries(billEntries: BillEntryProps[], style?: any): any {
        let elem: any[] = [];
        for(const entry of billEntries) {
            elem.push(<BillEntry {...entry} style={style} />)
        }
        return elem;
    }

    return (
        <>
            <div className="Content">
                <h1 className="Logo-Wrapper">
                    <img src={logo} />
                </h1>
                <div className="Sub-Header">
                    <h2>{props.billHeader + " " + PdfDataService.getDateString("de-DE")}</h2>
                </div>
                <div className="CostHeader">{props.boothHeader.toUpperCase()}</div>
                {renderBillEntries([props.boothEntry], {marginBottom: "40px"})}
                <div className="CostHeader">{props.billEntryHeader}</div>
                {renderBillEntries(props.billEntries)}
                <BillResult {...props.billResult}/>
                {/*<BillResult multi={{disclaimer: "NETTO GESAMTBETRAG INKL. STANDMIETE. ZZGL. MWST.", entries: [
                    {
                        totalCost: "11.000€",
                        type: "SIGN",
                        priceInfo: "100€/m²"
                    }, {
                        totalCost: "14.000€",
                        type: "COLUMN",
                        priceInfo: "150€/m²"
                    }
                ]}} />*/}
            </div>
            <BoothPreview sign={true} column={true} useOvergrowth={false}/>
            <div className="BillDisclaimerWrapper">
                <div className="BillDisclaimer">
                    {props.disclaimer}
                </div>
            </div>
            <Footer date={props.date} isSmall={true}/>
        </>
    );
}

export default CompleteView;
